// import slugify from 'slugify'
import * as Sentry from '@sentry/browser'
// import dayjs from 'dayjs'
import { perf } from './firebase-init'

export const exportFattura = (element) => {
  const trace = perf.trace('exportFattura')
  trace.start()
  try {
    const JSPDF = require('jspdf')

    // eslint-disable-next-line no-undef
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const contentDataURL = canvas.toDataURL('image/png')
      const pdf = new JSPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      })

      const m = 15
      const k = 43 / 30
      const w = (297 - m * 3) / 2
      const h = k * w
      pdf.addImage(contentDataURL, 'PNG', m, m, w, h)
      pdf.addImage(contentDataURL, 'PNG', m + m + w, m, w, h)
      pdf.save('fattura.pdf') // Generated PDF
    })
  } catch (e) {
    Sentry.captureException(e)
  }
  trace.stop()
}
